import * as React from 'react'

import { cn } from '../../utils/cn'
import { Badge } from './badge'
import { Button } from './button'
import { Card } from './card'

type IdeaCardProps = Omit<React.ComponentProps<'div'>, 'title'> & {
  title: string
  description: string
  /** A small label above the title, such as "New" or "Beta". */
  badge?: string
  actionLabel: string
  onAction?: () => void
  href?: string
  /** An offer for another Cai product: a green ground and the primary button. */
  upsell?: boolean
}

/** Something Cai suggests doing next, with one button that starts it. */
function IdeaCard({
  title,
  description,
  badge,
  actionLabel,
  onAction,
  href,
  upsell = false,
  className,
  ...props
}: IdeaCardProps) {
  return (
    <Card
      data-slot="idea-card"
      className={cn('@container/idea-card', upsell && 'bg-brand-50 border-brand-200', className)}
      {...props}
    >
      <div className="flex flex-col items-start gap-4 px-6 @md/idea-card:flex-row @md/idea-card:items-center @md/idea-card:gap-8">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          {badge && <Badge variant="secondary">{badge}</Badge>}
          <h3 className="text-ink text-md font-medium">{title}</h3>
          <p className="text-ink-500 text-sm">{description}</p>
        </div>
        <Button variant={upsell ? 'default' : 'outline'} href={href} onClick={onAction}>
          {actionLabel}
        </Button>
      </div>
    </Card>
  )
}

export { IdeaCard }
